export enum ELicenseChannelState {
  Unavailable = 'UNAVAILABLE',
  Inactive = 'INACTIVE',
  Active = 'ACTIVE',
}
